<template>
    <div class="flex-left" v-if="rowData.categories.length">
        <badge v-for="category in rowData.categories" :key="category.id"
                :username="category.name"
                :backgroundColor="category.color"></badge>
    </div>
</template>

<script>
  import Badge from '@/components/widgets/BadgeWidget'

  export default {
    components: {Badge},
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/CategoriesCell.vue